<template>
  <v-container
    fluid
    v-if="pcq.id"
  >
    <div class="mb-5 d-flex justify-center">
      <avs-createButton
        @click.stop="handleCreateAction"
        :name="$t('actions.new_female', { entity: $t('commons.signature').toLowerCase() })"
        :spantext="$t('actions.add', { entity: $t('commons.signature').toLowerCase() })"
      >
      </avs-createButton>
    </div>

    <v-expansion-panels
      focusable
      v-model="panelOpen"
    >
      <v-expansion-panel
        v-for="(action, index) in this.actions"
        :key="index"
      >
        <v-expansion-panel-header class="d-flex align-center">
          <div class="d-flex align-center justify-space-between">
            <v-col cols="5">
              <span>{{ $tc("commons.signature", 1) }} : {{ action.section }}</span>
            </v-col>

            <v-col cols="3">
              <span
                v-if="!isSaved[index]"
                class="d-flex align-center error--text"
              >
                <v-icon class="mr-2 error--text"> mdi-alert-outline </v-icon> Signature not yet
                saved
              </span>
            </v-col>
            <v-col
              class="d-flex justify-end"
              cols="3"
            >
              <component :is="handleStatusComponent(action)" />
            </v-col>
            <avs-deleteButton
              @click.stop="handleRemoveAction(action, index)"
              :spantext="$t('actions.delete', { entity: $t('commons.action').toLowerCase() })"
            />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-2">
          <PcqAction
            :value="action"
            :isSaved="isSaved[index]"
            :pcq="pcq"
            :projectId="projectId"
            :pcqLocked="pcqLocked"
            @update="v => handleActionUpdate(v, index)"
            @isSaved="v => updateIsSaved(v, index)"
            @isSigned="v => updateIsSign(v, index)"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- Modal de confirmation -->
    <avs-CloseActionDialog
      v-model="confirmationDialog"
      @cancel="handleActionCanceled"
      @close_action="confirmCreateAction"
    />
  </v-container>
</template>

<script>
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { PcqDsiService } from "@/services"
import { PcqAction } from "@/components"
import { mkPCQAction } from "@/utils/datamodels"

export default {
  name: "PcqActionList",
  components: { PcqAction, Closed, Ongoing, Overdue, Pending },
  props: {
    pcq: {
      type: Object,
      required: true
    },
    pcqValidate: {
      type: Boolean,
      required: false,
      default: false
    },
    pcqLocked: {
      type: Boolean,
      required: false,
      default: false
    },
    projectId: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchAllActions()
  },
  data() {
    return {
      actions: [],
      isSaved: [],
      confirmationDialog: false, // État pour gérer l'affichage du modal
      pendingAction: null,
      panelOpen: null
    }
  },
  methods: {
    handleCreateAction() {
      this.createNewAction()
      // Vérifie si la dernière action n'est pas fermée
      /*if (this.actions.length > 0 && this.actions[this.actions.length - 1].status !== "Closed") {
        this.confirmationDialog = true
      } else {
        this.createNewAction()
      }*/
    },
    handleActionCanceled() {
      this.confirmationDialog = false
      this.createNewAction()
    },
    confirmCreateAction() {
      const lastAction = this.actions[this.actions.length - 1]
      PcqDsiService.closeAction(this, lastAction.id)
        .then(r => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.closed", {
              entity: this.$tc("categories.pcq.name", 1)
            }),
            color: "success"
          })
          this.closeDialogIsOpen = false
          this.isClosed = true
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.confirmationDialog = false
      this.createNewAction()
      this.fetchAllActions()
    },
    createNewAction() {
      let action = mkPCQAction(this.pcq.id, this.actions.length + 1)
      this.actions.push(action)
      this.isSaved.push(false)
      this.panelOpen = this.actions.length - 1
    },
    handleRemoveAction(action, index) {
      if (action.id) PcqDsiService.deleteAction(action.id)
      this.actions.splice(index, 1)
      this.isSaved.splice(index, 1)
    },
    handleActionUpdate(action, index) {
      this.$set(this.actions, index, action)
    },
    handleStatusComponent(action) {
      return action.status
    },
    updateIsSaved(v, index) {
      this.$set(this.isSaved, index, v)
    },
    updateIsSign(v, index) {
      this.$store.commit("app/message", {
        msg: this.$t("messages.success.signed", {
          entity: this.$tc("commons.action", 1)
        }),
        color: "success"
      })
      this.fetchAllActions()
    },
    async fetchAllActions() {
      await PcqDsiService.getAllActions(this.pcq.id)
        .then(response => {
          this.actions = response.results
          this.isSaved = Array(this.actions.length).fill(true)
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
    }
  },
  watch: {}
}
</script>
